import classNames from 'classnames';
import React, { useState } from 'react';
import { majorScale } from '.';
import { useStores } from '../stores';
import { Spinner } from './Spinner';
import { Document, Page, pdfjs } from 'react-pdf';

import AutoSizer from 'react-virtualized-auto-sizer';

import styles from './PDFRenderer.module.scss';

// TODO: Maybe we should not use a hosted version...
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const PDFRenderer = React.memo(
  ({
    url,
    language,
    noAuth,
  }: {
    url: string;
    language: string;
    noAuth?: boolean;
  }) => {
    const { authStore } = useStores();
    const [pages, setPages] = useState(1);

    return (
      <AutoSizer disableHeight>
        {({ width, height }) => (
          <Document
            file={{
              url,
              httpHeaders: {
                Authorization: noAuth
                  ? undefined
                  : `Token ${authStore.authToken}`,
                'Accept-Language': language,
              },
            }}
            onLoadError={(error: any) => {
              console.log(error);
            }}
            onLoadSuccess={(pdf) => setPages(pdf.numPages)}
            loading={
              <div className="w-full flex items-center justify-center">
                <Spinner marginTop={majorScale(4)} marginX={majorScale(2)} />
              </div>
            }
            className={classNames(
              styles.pdfDoc,
              'flex items-center justify-center flex-col'
            )}
          >
            {new Array(pages).fill(0).map((_, i) => (
              <Page
                key={i}
                className={classNames(styles.pdfPage, 'shadow')}
                pageNumber={i + 1}
                width={Math.min(width, 800)}
                loading={<Spinner margin={majorScale(0)} />}
              />
            ))}
          </Document>
        )}
      </AutoSizer>
    );
  }
);
